"use strict";

import { authConstants } from "../_constants";

export const loginAuthRequest = (payload) => {
    return {
        type: authConstants.AUTH_LOGIN_REQUEST,
        payload,
    };
};

export const loginAuthComplete = (payload) => {
    return {
        type: authConstants.AUTH_LOGIN_COMPLETE,
        payload,
    };
};

export const logoutAuthRequest = (payload) => {
    return {
        type: authConstants.AUTH_LOGOUT_REQUEST,
        payload,
    };
};

export const logoutAuthComplete = (payload) => {
    return {
        type: authConstants.AUTH_LOGOUT_COMPLETE,
        payload,
    };
};

export const authUserProfileDetailsRequest = (payload) => {
    return {
        type: authConstants.AUTH_USER_PROFILE_DEATAILS_REQUEST,
        payload,
    };
};

export const authUserProfileDetailsComplete = (payload) => {
    return {
        type: authConstants.AUTH_USER_PROFILE_DEATAILS_COMPLETE,
        payload,
    };
};

export const refreshTokenAuthRequest = (payload) => {
    return {
        type: authConstants.AUTH_GET_REFRESH_TOKEN_REQUEST,
        payload,
    };
};

export const refreshTokenAuthComplete = (payload) => {
    return {
        type: authConstants.AUTH_GET_REFRESH_TOKEN_COMPLETE,
        payload,
    };
};

export const preRegistrationRequest = (payload) => {
    return {
        type: authConstants.PRE_REGISTRATION_REQUEST,
        payload,
    };
};

export const preRegistrationComplete = (payload) => {
    return {
        type: authConstants.PRE_REGISTRATION_COMPLETE,
        payload,
    };
};

export const preRegistrationActivateRequest = (payload) => {
    return {
        type: authConstants.PRE_REGISTRATION_ACTIVATE_REQUEST,
        payload,
    };
};

export const preRegistrationActivateComplete = (payload) => {
    return {
        type: authConstants.PRE_REGISTRATION_ACTIVATE_COMPLETE,
        payload,
    };
};


export const sendOtpRequest = (payload) => {
     return {
          type: authConstants.SEND_OTP_REQUEST,
          payload,
     };
};

export const sendOtpComplete = (payload) => {
     return {
          type: authConstants.SEND_OTP_COMPLETE,
          payload,
     };
};

export const reSendOtpRequest = (payload) => {
     return {
          type: authConstants.RE_SEND_OTP_REQUEST,
          payload,
     };
};

export const reSendOtpComplete = (payload) => {
     return {
          type: authConstants.RE_SEND_OTP_COMPLETE,
          payload,
     };
};

export const forgotPasswordEmailVeryficationRequest = (payload) => {
     return {
          type: authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST,
          payload,
     };
};

export const forgotPasswordEmailVeryficationComplete = (payload) => {
     return {
          type: authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE,
          payload,
     };
};

export const forgotPasswordResetPasswordRequest = (payload) => {
     return {
          type: authConstants.FORGOT_PASSWORD_RESET_PASSWORD_REQUEST,
          payload,
     };
};

export const forgotPasswordResetPasswordComplete = (payload) => {
     return {
          type: authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE,
          payload,
     };
};

export const authGetUserDetailsRequest = () => {
    return {
         type: authConstants.USER_DETAILS_REQUEST,
    };
};

export const authGetUserDetailsComplete = (payload) => {
    return {
         type: authConstants.USER_DETAILS_COMPLETE,
         payload,
    };
};